import PropTypes from 'prop-types';
import React from 'react';

import { ENUM_FONTS } from '@commons/Text';
import DisplayNumber from '@commons/DisplayNumber';

import { Container, TextContainer, Text } from './styledComponents';

const StockFromCategorySumup = (props) => {
  const { name, total, handleCategoryUnfolding, isCategoryOpen } = props;

  return (
    <Container isCategoryOpen={isCategoryOpen} onClick={() => handleCategoryUnfolding(name)}>
      <img
        src={
          !!isCategoryOpen
            ? '/images/inpulse/carret-bottom-black.svg'
            : '/images/inpulse/carret-right-black.svg'
        }
      />
      <TextContainer>
        <Text>{name}</Text>
        <DisplayNumber displayCurrencyCode={true} font={ENUM_FONTS.H2_INTER} number={total} />
      </TextContainer>
    </Container>
  );
};

StockFromCategorySumup.propTypes = {
  name: PropTypes.string.isRequired,
  total: PropTypes.number,
};

export default StockFromCategorySumup;
